function setRem () {
  const htmlWidth = document.documentElement.clientWidth || document.body.clientWidth
  const htmlDom = document.getElementsByTagName('html')[0]
  htmlDom.style.fontSize = 100 * (htmlWidth / 750) + 'px'
}
setRem()
window.onresize = function () {
  setRem()
}
